import{useRef as t}from"react";import{useIsoMorphicEffect as o}from"./use-iso-morphic-effect.js";function s(e){let r=t(e);return o(()=>{r.current=e},[e]),r}export{s as useLatestValue};
